document.addEventListener("change", function (event) {
  const toggle = event.target.closest?.("[data-host-offer-visibility-toggle]");
  if (!toggle) return;

  toggle.closest("form")?.requestSubmit();
});
